// extracted by mini-css-extract-plugin
module.exports = {"imageSelector":"EditLogo_imageSelector__3K-e_","box":"EditLogo_box__3dCTX"};